import { Anchor } from '@mantine/core';

import { CompanyProfile, PermissionCompany, PublishedStatus } from 'models';

import { ProfileNotice } from 'components/company-profile/components/ProfileNotice';
import { PublishButton } from 'components/company-profile/components/PublishButton';
import { useProfilePermission } from 'components/company-profile/hooks/use-profile-permission';

export const PublishProfileNotice = ({ company: company }: { company: CompanyProfile }) => {
    const canEdit = useProfilePermission(PermissionCompany.EDIT, company);

    if (!canEdit) {
        return null;
    }

    if (company.status === PublishedStatus.REVIEW) {
        return (
            <ProfileNotice title="Profile Under Review" color="brand">
                Your profile is currently under review. We will notify you once your profile has been published.{' '}
                <Anchor href="mailto:sales@directenergypartners.com" inherit c="inherit" fw={600}>
                    Contact us
                </Anchor>{' '}
                if your profile is not published within the next 24 hours.
            </ProfileNotice>
        );
    }

    if (company.status === PublishedStatus.DRAFT) {
        return (
            <ProfileNotice
                title="Profile not published"
                color="brand"
                action={<PublishButton company={company} variant="white" size="sm" radius="xs" />}
            >
                Request to publish your profile, we will review in 24 hours.
            </ProfileNotice>
        );
    }

    return null;
};
